"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deactivateItem = exports.activateItem = void 0;
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
/**
 * Calls activate API method.
 *
 *
 * @param api API endpoint
 * @param id Id of the item
 */
function activateItem(api, id) {
    return (0, abortable_fetch_1.abortableFetch)(`${api}/${id}/active`, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'PUT',
    });
}
exports.activateItem = activateItem;
/**
 * Calls deactivate API method.
 *
 *
 * @param api API endpoint
 * @param id Id of the item
 */
function deactivateItem(api, id) {
    return (0, abortable_fetch_1.abortableFetch)(`${api}/${id}/active`, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'DELETE',
    });
}
exports.deactivateItem = deactivateItem;
//# sourceMappingURL=dictionary-api.js.map